import React from 'react';
import classes from './SuggestionResult.module.scss.js';

const SuggestionResult = ({ geoOptionsLabels, query = '', }) => {
    const [label, extra] = geoOptionsLabels;
    let firstHalf;
    if (query.length > 0 && label.toLowerCase().startsWith(query.toLowerCase())) {
        firstHalf = (React.createElement("span", null,
            React.createElement("b", null, label.slice(0, query.length)),
            label.slice(query.length)));
    }
    else {
        firstHalf = label;
    }
    return (React.createElement(React.Fragment, null,
        firstHalf,
        extra != undefined ? (React.createElement(React.Fragment, null,
            "\u00A0",
            React.createElement("span", { className: classes['location-qualifier'] }, extra))) : null));
};

export { SuggestionResult as default };
//# sourceMappingURL=SuggestionResult.js.map
